import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessorKey", "label", "uiProps", "defaultValue"],
  _excluded2 = ["accessorKey", "items", "uiProps", "defaultValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONTROL } from '../../components';
export var UnitsOfCalculationItem = {
  Gb: 'gb',
  Tb: 'tb'
};
export var unitsOfCalculationItems = [{
  value: UnitsOfCalculationItem.Gb,
  label: 'ГБ'
}, {
  value: UnitsOfCalculationItem.Tb,
  label: 'ТБ'
}];
export function getObs(_ref) {
  var space = _ref.space,
    units = _ref.units;
  var _space$accessorKey = space.accessorKey,
    spaceKey = _space$accessorKey === void 0 ? 'obs.space' : _space$accessorKey,
    _space$label = space.label,
    spaceLabel = _space$label === void 0 ? 'Объем хранилища' : _space$label,
    spaceUiProps = space.uiProps,
    _space$defaultValue = space.defaultValue,
    spaceDefaultValue = _space$defaultValue === void 0 ? 0 : _space$defaultValue,
    restSpace = _objectWithoutProperties(space, _excluded);
  var _units$accessorKey = units.accessorKey,
    unitsKey = _units$accessorKey === void 0 ? 'obs.unitsOfCalculation' : _units$accessorKey,
    _units$items = units.items,
    unitsItems = _units$items === void 0 ? unitsOfCalculationItems : _units$items,
    unitUiProps = units.uiProps,
    _units$defaultValue = units.defaultValue,
    unitsDefaultValue = _units$defaultValue === void 0 ? UnitsOfCalculationItem.Gb : _units$defaultValue,
    restUnits = _objectWithoutProperties(units, _excluded2);
  return {
    type: CONTROL.Object,
    ui: [{
      controls: ['space', 'unitsOfCalculation']
    }],
    controls: {
      space: _objectSpread({
        type: CONTROL.Stepper,
        decoratorProps: {
          label: spaceLabel
        },
        accessorKey: spaceKey,
        defaultValue: spaceDefaultValue,
        uiProps: _objectSpread({
          min: 0,
          max: 9999999900,
          postfix: 'ГБ',
          showHint: false
        }, spaceUiProps),
        watchedControls: {
          unitsOfCalculation: unitsKey
        },
        relateFn: function relateFn(_ref2) {
          var unitsOfCalculation = _ref2.unitsOfCalculation;
          if (unitsOfCalculation === UnitsOfCalculationItem.Tb) {
            return {
              uiProps: {
                max: 9765620,
                postfix: 'ТБ'
              }
            };
          }
        }
      }, restSpace),
      unitsOfCalculation: _objectSpread({
        type: CONTROL.SelectSingle,
        accessorKey: unitsKey,
        decoratorProps: {
          label: ''
        },
        defaultValue: unitsDefaultValue,
        items: unitsItems,
        uiProps: _objectSpread({
          showClearButton: false,
          searchable: false
        }, unitUiProps)
      }, restUnits)
    }
  };
}